import React, { Component } from "react";
import { DataGrid, Column, Paging, Pager } from "devextreme-react/data-grid";
import uiInfo from "../../ui-info";
import PaginaToolbar from "../../components/PaginaToolbar";
import { criarNotaFiscalAvulsaDs } from "../../DataSources";
import Form, {
  SimpleItem,
  Label,
  EmptyItem,
} from "devextreme-react/form";
import { Button, ScrollView } from "devextreme-react";
import { abrirNotaAvulsa, detalheNotaAvulsa } from "../../lancamentosUtils";
import memoria from "../../Memoria";
import showReport from "../../showReport";
import UserInfo from "../../UserInfo";
import apiAxios from "../../api-axios";
import notify from "devextreme/ui/notify";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import ShowError from "../../AppServices";

export default class NotaFiscalAvulsaBox extends Component {
  constructor(props) {
    super(props);
    this._gridInstance = React.createRef();
    this._formInstance = React.createRef();
    this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
    this.state = {
      filtroCorrente: [],
      filtro: { nome: "", inativo: undefined, situacao: -1, tributacao: [] },
      popupMotivoCancelarNfse: false,
      nfseCancelamento: {},
      popupVerificarDados: false,
    };
    this.filtrar = this.filtrar.bind(this);
    this.limparFiltro = this.limparFiltro.bind(this);
    this.onSelecionado = props.onSelecionado;
    this.usadoComoPesquisa = props.onSelecionado !== undefined;
    this.nfDs = criarNotaFiscalAvulsaDs();
    this.itemLeitura = this.itemLeitura.bind(this);

    this.tributacaoOptions = {
      editorType: "dxTagBox",
      selectionMode: "multiple",
      searchEnabled: false,
      dataSource: [
        { id: 0, descricao: "TRIBUTAVEL" },
        { id: 1, descricao: "IMUNE" },
        { id: 2, descricao: "ISENTO" },
        { id: 3, descricao: "OUTRO MUNICIPIO" },
      ],
      placeholder: " ",
      valueExpr: "id",
      displayExpr: "descricao",
      showClearButton: true,
    };

    this.statusOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: -1, descricao: "TODAS" },
        { id: 0, descricao: "NORMAL" },
        { id: 1, descricao: "CANCELADA" }
      ],
      placeholder: " ",
      valueExpr: "id",
      displayExpr: "descricao",
      showClearButton: false,
    };
  }

  itemLeitura(data) {
    console.log(this.state.nfseCancelamento[data.dataField]);
    if (!this.state.nfseCancelamento) {
      return <span></span>;
    }
    return <span>{this.state.nfseCancelamento[data.dataField]}</span>;
  }

  limparCpfCnpj(cpfCnpj) {
    if (cpfCnpj == undefined || typeof cpfCnpj != "string") {
      console.log(typeof cpfCnpj);
      return cpfCnpj;
    }

    return cpfCnpj.replaceAll(".", "").replaceAll("-", "").replaceAll("/", "");
  }

  filtrar(e) {
    let filtro = this.state.filtro;

    let filtroCorrente = [];

    if (filtro.numero !== undefined && filtro.numero !== "") {
      filtroCorrente.push(["numero", "=", filtro.numero.trim()]);
    }

    if (filtro.cpfCnpjPrestador != undefined && filtro.cpfCnpjPrestador.trim() != "") {
      filtroCorrente.push([
        "prestador.cpfCnpj",
        "contains",
        this.limparCpfCnpj(filtro.cpfCnpjPrestador),
      ]);
    }

    if (filtro.nomePrestador !== undefined && filtro.nomePrestador !== "") {
      filtroCorrente.push([
        "prestador.nome",
        "contains",
        filtro.nomePrestador.trim(),
      ]);
    }

    if (filtro.cpfCnpjTomador!= undefined && filtro.cpfCnpjTomador.trim() != "") {
      filtroCorrente.push([
        "tomador.cpfCnpj",
        "contains",
        this.limparCpfCnpj(filtro.cpfCnpjTomador),
      ]);
    }

    if (filtro.nomeTomador !== undefined && filtro.nomeTomador !== "") {
      filtroCorrente.push([
        "tomador.nome",
        "contains",
        filtro.nomeTomador.trim(),
      ]);
    }

    if (filtro.dataInicial != undefined) {
      const data = filtro.dataInicial;
      filtroCorrente.push([
        "dataDeEmissao",
        ">=",
        new Date(
          data.getFullYear(),
          data.getMonth(),
          data.getDate(),
          0,
          0,
          0,
          0
        ),
      ]);
    }

    if (filtro.dataFinal != undefined) {
      const data = filtro.dataFinal;
      filtroCorrente.push([
        "dataDeEmissao",
        "<=",
        new Date(
          data.getFullYear(),
          data.getMonth(),
          data.getDate(),
          23,
          5,
          59,
          999
        ),
      ]);
    }

    if (filtro.valorInicial != undefined) {
      filtroCorrente.push(["valorTotal", ">=", filtro.valorInicial]);
    }

    if (filtro.valorFinal != undefined) {
      filtroCorrente.push(["valorTotal", "<=", filtro.valorFinal]);
    }

    if (filtro.tributacao != undefined && filtro.tributacao.length > 0) {
      let tipoArray = [];
      filtro.tributacao.map(item => tipoArray.push(["tributacaoIss", "=", item], "or"))
      tipoArray.pop();
      filtroCorrente.push(tipoArray);
    }

    if (filtro.tributacao != undefined && filtro.tributacao.length > 0) {
      let tipoArray = [];
      filtro.tributacao.map(item => tipoArray.push(["tributacaoIss", "=", item], "or"))
      tipoArray.pop();
      filtroCorrente.push(tipoArray);
    }

    if (filtro.situacao != undefined && filtro.situacao != -1) {
      filtroCorrente.push(["status", "=", filtro.situacao]);
    }

    console.log("filtro", filtroCorrente);
    this._gridInstance.instance.filter(
      filtroCorrente.length > 0 ? filtroCorrente : null
    );
  }

  limparFiltro(e) {
    this.setState({ filtro: { situacao: -1, tributacao: [], dataInicial: undefined, dataFinal: undefined } });
    this.filtrar();
    this._formInstance.instance.repaint();
  }

  onAtualizandoRow(e) {
    e.cancel = true;
  }

  componentDidMount() {
    memoria.redirecionarSeNecessario(
      { pathname: "/emissao_nf_avulsa" },
      this.props.history
    );
  }

  async cancelarNfse() {
    const registro = this.state.nfseCancelamento;

    if (this.state.motivoCancelamento == null)
      notify("Campo Motivo do Cancelamento precisa ser preenchido", "warning");
    else {
      try {
        const data = {
          id: registro.id,
          motivoCancelamento: this.state.motivoCancelamento,
        };

        const response = await apiAxios.post(
          `nota_fiscal_avulsa/cancelar/${UserInfo.getPrefeitura()}`,
          data
        );

        if (response.status === 200) {
          notify("NFSe Avulsa cancelada com sucesso!", "success");
        }

        this.setState({ ...this.state, popupVerificarDados: false });
        this._gridInstance.instance.refresh();
      } catch (error) {
        ShowError(error.response.data);
        notify(error, "error", 2000);
      }
    }
  }

  popupVerificarDados(e) {
    const registro = e.row.data;

    return this.setState({
      ...this.state,
      nfseCancelamento: registro,
      popupVerificarDados: true,
    });
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <form onSubmit={this.filtrar}>
            <Form
              id="frmPesquisa"
              formData={this.state.filtro}
              colCount={6}
              labelLocation={"top"}
              ref={form => this._formInstance = form}
            >
              <SimpleItem dataField="numero" colSpan={1}>
                <Label text="Número" />
              </SimpleItem>
              <SimpleItem dataField="dataInicial" colSpan={1} editorType={"dxDateBox"} editorOptions={{ width: "100%", useMaskBehavior: true, showClearButton: true }}>
                <Label text="Dt. Emissão Inicial" />
              </SimpleItem>
              <SimpleItem dataField="dataFinal" colSpan={1} editorType={"dxDateBox"} editorOptions={{ width: "100%", useMaskBehavior: true, showClearButton: true }}>
                <Label text="Dt. Emissão Final" />
              </SimpleItem>
              <SimpleItem dataField="valorInicial" colSpan={1} editorType={"dxNumberBox"}
                editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                cssClass={"txtFrmCpbsNumerico"}>
                <Label text="Vr. Inicial" />
              </SimpleItem>
              <SimpleItem dataField="valorFinal" colSpan={1} editorType={"dxNumberBox"}
                editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                cssClass={"txtFrmCpbsNumerico"}>
                <Label text="Vr. Final" />
              </SimpleItem>
              <SimpleItem dataField="tributacao" colSpan={1} editorType={"dxTagBox"} editorOptions={this.tributacaoOptions} >
                <Label text="Tributação" />
              </SimpleItem>
              <SimpleItem dataField="situacao" colSpan={1} editorType={"dxSelectBox"} editorOptions={this.statusOptions}>
                <Label text="Situação" />
              </SimpleItem>
              <SimpleItem dataField="cpfCnpjPrestador" colSpan={1}>
                <Label text="CPF/CNPJ Prestador" />
              </SimpleItem>
              <SimpleItem dataField="nomePrestador" colSpan={2}>
                <Label text="Nome do Prestador" />
              </SimpleItem>
              <SimpleItem dataField="cpfCnpjTomador" colSpan={1}>
                <Label text="CPF/CNPJ Tomador" />
              </SimpleItem>
              <SimpleItem dataField="nomeTomador" colSpan={2}>
                <Label text="Nome do Tomador" />
              </SimpleItem>
              <EmptyItem colSpan={2} />
            </Form>
            <div style={{ marginTop: "10px" }}>
              <div style={{ display: "inline-block" }}>
                <Button
                  width={120}
                  text="Filtrar"
                  type="success"
                  onClick={this.filtrar}
                />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button text="Limpar Filtro" onClick={this.limparFiltro} />
              </div>
            </div>
          </form>
          <br />
          <PaginaToolbar
            titulo="NOTAS FISCAIS AVULSAS"
            novoCb={this.novoRegistro.bind(this)}
          >
            <DataGrid
              ref={(grid) => (this._gridInstance = grid)}
              dataSource={this.nfDs}
              showBorders={true}
              rowAlternationEnabled={true}
              remoteOperations={true}
              columnAutoWidth={true}
              focusedRowEnabled={true}
              filterSyncEnabled={true}
            >
              <Column
                type="buttons"
                fixed={true}
                fixedPosition={"left"}
                buttons={[
                  {
                    hint: "Cancelar",
                    icon: "remove",
                    onClick: (e) => {
                      this.popupVerificarDados(e);
                    },
                  },
                  {
                    hint: "Editar",
                    icon: "edit",
                    onClick: (e) =>
                      abrirNotaAvulsa(this.props.history, e.row.data),
                  },
                  {
                    hint: "Imprimir NF",
                    icon: "exportpdf",
                    onClick: (e) => {
                      console.log("nf e", e);
                      showReport(
                        `report/nfavulsa/${UserInfo.getPrefeitura()}/${e.row.data.id
                        }`
                      );
                    },
                  },
                  {
                    hint: "Imprimir Boletos",
                    icon: "exportpdf",
                    onClick: function () {
                      alert("Boletos");
                    },
                  },
                  {
                    hint: "Detalhes",
                    icon: "more",
                    onClick: (e) =>
                      detalheNotaAvulsa(this.props.history, e.row.data),
                  },
                ]}
              />

              <Column
                dataField={"id"}
                allowEditing={false}
                visible={false}
                alignment={"center"}
              />

              <Column
                dataField={"sequencial"}
                caption={"#"}
                allowEditing={false}
                alignment={"center"}
                sortOrder={"desc"}
                width={"80"}
              />

              <Column
                dataField={"numero"}
                caption={"Número"}
                allowEditing={false}
                width={100}
                alignment={"center"}
              />

              <Column
                dataField={"dataDeEmissao"}
                dataType={"date"}
                caption={"Emissão"}
                alignment={"center"}
                width={110}
              />

              <Column
                dataField={"tributacaoIssStr"}
                caption={"Tributação"}
                alignment={"center"}
                width={120}
              />

              <Column
                dataField={"statusStr"}
                caption={"Situação"}
                alignment={"center"}
                width={120}
              />

              <Column dataField={"prestador.cpfCnpj"} caption={"CPF/CNPJ Prestador Limpo"} visible={false} showInColumnChooser={false} />
              <Column dataField={"prestador.cpfCnpjFormatado"} caption={"CPF/CNPJ Prestador"} visible={true} />
              <Column dataField={"prestador.nome"} caption={"Prestador"} />

              <Column dataField={"tomador.cpfCnpj"} caption={"CPF/CNPJ Tomador Limpo"} visible={false} showInColumnChooser={false} />
              <Column dataField={"tomador.cpfCnpjFormatado"} caption={"CPF/CNPJ Tomador"} visible={true} />
              <Column dataField={"tomador.nome"} caption={"Tomador"} />

              <Column
                dataField={"valorTotal"}
                caption={"Valor Total (R$)"}
                width={120}
                format={{ type: "fixedPoint", precision: 2 }}
              />

              <Column
                dataField={"iss"}
                caption={"ISS (R$)"}
                width={120}
                format={{ type: "fixedPoint", precision: 2 }}
              />

              <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
              <Pager
                showPageSizeSelector={true}
                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
              />
            </DataGrid>
          </PaginaToolbar>

          <Popup
            visible={this.state.popupVerificarDados}
            onHiding={() => this.setState({ popupVerificarDados: false })}
            dragEnabled={false}
            closeOnOutsideClick={true}
            showCloseButton={true}
            showTitle={true}
            width={600}
            height={450}
            title="Verificar Dados Para Cancelamento"
          >
            <ScrollView showScrollbar="always">
              <form>
                <Form formData={this.state.nfseCancelamento}>
                  <SimpleItem
                    dataField={"numero"}
                    render={() => (
                      <span>
                        {this.state.nfseCancelamento &&
                          this.state.nfseCancelamento.numero}
                      </span>
                    )}
                  >
                    <Label text="Número" />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"tomador.nome"}
                    render={() => (
                      <span>
                        {this.state.nfseCancelamento.tomador &&
                          this.state.nfseCancelamento.tomador.nome}
                      </span>
                    )}
                  >
                    <Label text="Nome do Tomador" />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"tomador.documento"}
                    render={() => (
                      <span>
                        {this.state.nfseCancelamento.tomador &&
                          this.state.nfseCancelamento.tomador.documento}
                      </span>
                    )}
                  >
                    <Label text="Documento do Tomador" />
                  </SimpleItem>

                  <SimpleItem
                    dataField={"servico.descricao"}
                    render={() => (
                      <span>
                        {this.state.nfseCancelamento.servico &&
                          this.state.nfseCancelamento.servico.descricao}
                      </span>
                    )}
                  >
                    <Label text="Serviço Prestado" />
                  </SimpleItem>
                </Form>
                <br />
                <br />
                <Form formData={this.state} colCount={1} labelLocation="top">
                  <SimpleItem
                    dataField={"motivoCancelamento"}
                    editorType={"dxTextArea"}
                    editorOptions={{
                      placeholder: "Digite aqui...",
                      height: "100px",
                    }}
                  >
                    <Label text="Motivo do Cancelamento" />
                  </SimpleItem>
                </Form>
              </form>
            </ScrollView>
            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Confirmar",
                type: "success",
                width: 150,
                onClick: () => {
                  this.cancelarNfse();
                },
              }}
            />
            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Cancelar",
                type: "default",
                width: 150,
                onClick: () => {
                  this.setState({ popupVerificarDados: false });
                  return notify("Operação cancelada!", "warning");
                },
              }}
            />
          </Popup>
        </div>
      </React.Fragment>
    );
  }

  novoRegistro() {
    this.props.history.push("/emissao_nf_avulsa");
  }
}

